import Vue from 'vue';
import Vuex from 'vuex';
// import app from './modules/app';
// import errorLog from './modules/errorLog';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isShowNav: true,
    isHome: false,
  },
  mutations: {
    showNav(state, to) {
      state.isHome = to.path === '/' ? true : false;
      if (to.name === 'FormList' || to.name === 'QuizDetail') {
        state.isShowNav = false;
      } else {
        state.isShowNav = true;
      }
    }
  },
  modules: {
    // app,
    // errorLog
  },
  getters
});

export default store;
